<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <div class="flex justify-between">
              <h2 class="text-xl font-semibold" >
                Total -
                <span>{{ count_list || 0 }}</span>
              
              </h2>
              <router-link :to="{ name: 'AdminDashboards' }">
                <button class="bg-blues text-white py-1 px-3 rounded-lg">
                  Back
                </button>
              </router-link>
            </div>
            <div class="flex">
              <form
                @submit.prevent="searchUserValue"
                class="flex w-full md:w-auto"
              >
                <input
                  type="text"
                  placeholder="Search here"
                  v-model="searching"
                  @input="searchUserValue"
                  class="px-4 py-2 rounded-l-md border border-gray-300 focus:outline-none"
                />
                <button class="bg-blues text-white px-4 py-2 rounded-r-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </form>
            </div>

            <!-- <div class="flex justify-between">
              <h1 class="text-lg font-semibold dark_text">Details</h1>
            </div> -->

            <div class="text-[#0085DB] font-bold">
              <ul class="breadcrumb flex">
                <li
                  v-for="(item, index) in b_value"
                  :key="index"
                  :class="{
                    'breadcrumb-item': !isActive(index),
                    'active-breadcrumb-item': isActive(index),
                  }"
                >
                  <span
                    class="pl-2 text-sm"
                    :class="{ 'breadcrumb-text': !isActive(index) }"
                  >
                    <router-link :to="{ name: item.name }">{{
                      item.text
                    }}</router-link>
                  </span>
                  <span
                    v-if="index < b_value.length - 1"
                    class="breadcrumb-arrow"
                  >
                    &gt;
                  </span>
                </li>
              </ul>
            </div>

            <div class="w-full overflow-scroll">
              <table class="min-w-full">
                <thead>
                  <tr
                    class="text-left bg-blues text whitespace-nowrap text-sm"
                  >
                    <th class="px-6 py-3">S.No</th>
                    <th class="px-6 py-3">Email</th>
                    <th class="px-6 py-3">Display name</th>
                     <th class="px-6 py-3">Mobile</th>
                    <th class="px-6 py-3">Permission</th>
                    <th class="px-6 py-3">Batch</th>
                    <th class="px-6 py-3">Semester</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                  <tr class="w-full">
                    <td colspan="12" class="text-center py-6">
                      <div class="flex items-center justify-center">
                        <img src="@/assets/attendance/loading.gif" alt="" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <template v-if="programs.length > 0">
                    <tr
                      v-for="(list, index) in programs"
                      :key="index"
                      class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                    >
                      <td class="px-6 py-3">
                        {{ (currentPage - 1) * perPage + index + 1 }}
                      </td>

                      <td class="px-6 py-3">
                        <span v-if="list.email != null">{{ list.email }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.display_name != null">{{
                          list.display_name
                        }}</span
                        ><span v-else>---</span>
                      </td>
                       <td class="px-6 py-3">
                        <span v-if="list.mobile != null">{{
                          list.mobile
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.permission != null">{{
                          list.permission
                        }}</span
                        ><span v-else>---</span>
                      </td>
                       <td class="px-6 py-3">
                        <span v-if="list.batch != null">{{
                          list.batch
                        }}</span
                        ><span v-else>---</span>
                      </td>
                       <td class="px-6 py-3 ">
                        <span v-if="list.semester != null">{{
                          list.semester
                        }}</span
                        ><span v-else>---</span>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="11" class="px-6 py-3 text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
                <!-- <tfoot>
                  <tr>
                    <td colspan="11" class="p-6 bg-[#18469d]"></td>
                  </tr>
                </tfoot> -->
                <tfoot v-if="totalPages > 1" class="">
                  <tr>
                    <td colspan="7" class="bg-blues">
                      <div class="flex justify-center py-4 space-x-2">
                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage === 1"
                          @click="prevPage"
                        >
                          &laquo;
                        </button>

                        <button
                          v-for="page in paginationRange"
                          :key="page"
                          class="px-3 py-2 rounded"
                          :class="{
                            'bg-blue-800 text-white': currentPage === page,
                            'bg-white border border-gray-400 text-gray-800':
                              currentPage !== page,
                          }"
                          @click="changePage(page)"
                        >
                          {{ page }}
                        </button>

                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage >= totalPages"
                          @click="nextPage"
                        >
                          &raquo;
                        </button>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //   loading: true,
      messages: {
        text: "",
        type: "null",
      },
      selectsemester: "",
      selectPatch: "",
      selectdepartment: "",
      selectprogram: "",
      selectsession: "",
      selectsection: "",
      programs: [],

      count_list: "",
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",
      b_value: [],
    };
  },
  props: ["program_id", "p_name"],
  components: {
    SideBar,
    FlashMessage,
  },
  async created() {
    this.b_value = [
      { text: "Dashboard", name: "AdminDashboards" },
      { text: "Programs", name: "AdminDashboards" },
      { text: this.p_name },
    ];
    await this.programget();
  },

  computed: {
    ...mapGetters(["userInfo"]),
    paginationRange() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      let pages = [];

      if (totalPages <= 5) {
        pages = [...Array(totalPages).keys()].map((x) => x + 1);
      } else {
        if (currentPage > 3) pages.push(1);
        if (currentPage > 4) pages.push("...");

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (currentPage < totalPages - 3) pages.push("...");
        if (currentPage < totalPages - 2) pages.push(totalPages);
      }

      return pages;
    },
  },
  methods: {
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    async programget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-department-user-details-get/${this.program_id}/?Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.programs = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.programs", this.programs);
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-department-user-details-get/${this.program_id}/?search=${this.searching}&Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.programs = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.department123", this.programs);
          }
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.programget();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.programget();
      }
    },
    changePage(page) {
      if (page !== "..." && page !== this.currentPage) {
        this.currentPage = page;
        this.programget();
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
